import styled from 'react-emotion';
import UnstyledSeparator from '@ublend-npm/aulaui-next-web/Separator';

const Separator = styled(UnstyledSeparator)`
  height: ${(props) => props.height};
  background-color: transparent;
`;

export default Separator;
